import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { clearProductSwitch, useProductSwitchDispatch } from './product-switch/product-switch-duck';
import { showNotification } from '../notifications/ducks/notifications';
import Icon, { ICON_STOPWATCH_LINE } from '~/components/icon/index.js';
import { useSelector } from 'react-redux';
import { selectCoolOffPeriodOn } from './reality-check/ducks/selectors';
import { getSecondsElapsedFromTimestamp } from './product-switch/product-switch-utils';

const ActiveProductWrapper = styled.div`
	padding: 0 4px;
	display: flex;
`;

const ActiveProduct = styled.span`
	width: auto;
	background-color: ${props =>
		props.hasCoolOff ? 'var(--activeProductBg, rgba(var(--info), 1))' : 'var(--notActiveProductBg)'};
	border-radius: 20px;
	padding: 8px;
	margin: ${props => (props.productSwitchPopup ? '0 auto' : '0 3px')};
	min-width: 32px;
	display: inherit;
	align-items: center;
`;

const Time = styled.span`
	padding-left: 4px;
`;

const parseSecondsToTime = value => {
	const minutes = Math.floor(value / 60);
	const seconds = value - minutes * 60;
	const parsedSeconds = seconds >= 10 ? seconds : `0${seconds}`;

	return `${minutes}:${parsedSeconds}`;
};

const ActiveProducts = ({ productSwitchPopup, timer, product, onEndMessage }) => {
	const dispatch = useProductSwitchDispatch();
	const coolOffPeriodOn = useSelector(selectCoolOffPeriodOn);

	const [state, setState] = useState({
		timer: ''
	});

	useEffect(() => {
		let val = Number(getSecondsElapsedFromTimestamp(timer));
		if (Number.isNaN(val)) {
			return;
		}
		const interval = setInterval(() => {
			val -= 1;
			const timerVal = parseSecondsToTime(val);
			if (val > -1) {
				setState({
					timer: timerVal
				});
			} else {
				dispatch(clearProductSwitch);
				clearInterval(interval);
				setState({
					timer: ''
				});

				if (onEndMessage && timer > 0 && !coolOffPeriodOn) {
					dispatch(
						showNotification({
							message: onEndMessage,
							color: 'neutral',
							autoHide: true,
							openInSidebar: false
						})
					);
				}
			}
		}, 1000);

		return () => {
			clearInterval(interval);
			setState({
				timer: ''
			});
		};
	}, [timer, dispatch, onEndMessage, coolOffPeriodOn]);

	return (
		state.timer &&
		state.timer !== '0' && (
			<ActiveProductWrapper productSwitchPopup={productSwitchPopup}>
				{!productSwitchPopup && <ActiveProduct key={product} hasCoolOff={timer} />}
				<ActiveProduct productSwitchPopup={productSwitchPopup} hasCoolOff={timer} coolOffProduct>
					<Icon type={ICON_STOPWATCH_LINE} height="13.5" width="13.5" />
					<Time>{state.timer}</Time>
				</ActiveProduct>
			</ActiveProductWrapper>
		)
	);
};

export default ActiveProducts;
